/* ==========================================================================
   ANNAPURNA PEAK — theme.js (sin dependencias)
   ========================================================================== */
(() => {
  const root = document.documentElement;
  const body = document.body;
  const T = window.theme || { routes: { root: '/' }, strings: {}, cartType: 'page' };
  const RM = matchMedia('(prefers-reduced-motion: reduce)').matches || body.classList.contains('no-anim');
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];

  /* ---------------- Header: altura + estado sólido ---------------- */
  const header = $('.site-header');
  if (header) {
    const setH = () => root.style.setProperty('--header-h', header.offsetHeight + 'px');
    setH();
    if ('ResizeObserver' in window) new ResizeObserver(setH).observe(header);
    const solid = () => header.classList.toggle('is-solid', scrollY > 40 || body.classList.contains('is-locked'));
    solid();
    addEventListener('scroll', solid, { passive: true });
  }

  /* ---------------- Reveal ---------------- */
  const initReveal = (scope = document) => {
    const els = $$('.reveal:not(.is-in)', scope);
    if (RM || !('IntersectionObserver' in window)) { els.forEach(el => el.classList.add('is-in')); return; }
    const io = new IntersectionObserver(entries => entries.forEach(e => {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    }), { threshold: .15, rootMargin: '0px 0px -5% 0px' });
    els.forEach(el => io.observe(el));
  };
  initReveal();

  /* ---------------- Contadores ---------------- */
  const initCounters = (scope = document) => {
    const els = $$('[data-count-to]', scope);
    if (!els.length || !('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver(entries => entries.forEach(e => {
      if (!e.isIntersecting) return;
      io.unobserve(e.target);
      const el = e.target, to = +el.dataset.countTo;
      if (RM) { el.textContent = to; return; }
      const t0 = performance.now(), dur = 1600;
      const tick = now => {
        const k = Math.min(1, (now - t0) / dur);
        el.textContent = Math.round(to * (1 - Math.pow(1 - k, 4)));
        if (k < 1) requestAnimationFrame(tick);
      };
      el.textContent = '0';
      requestAnimationFrame(tick);
    }), { threshold: .5 });
    els.forEach(el => io.observe(el));
  };
  initCounters();

  /* ---------------- Hero ---------------- */
  requestAnimationFrame(() => $$('.hero').forEach(h => h.classList.add('is-ready')));
  const par = $$('.is-parallax');
  if (par.length && !RM) {
    let tick = false;
    const run = () => {
      tick = false;
      if (innerWidth < 750) return;
      par.forEach(el => {
        const r = el.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > innerHeight) return;
        el.style.setProperty('--py', (r.top * -0.18).toFixed(1) + 'px');
      });
    };
    addEventListener('scroll', () => { if (!tick) { tick = true; requestAnimationFrame(run); } }, { passive: true });
    run();
  }

  /* ---------------- Drawers ---------------- */
  let lastFocus = null;
  const openDrawer = id => {
    const d = document.getElementById(id);
    if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    body.classList.add('is-locked');
    header && header.classList.add('is-solid');
    const f = d.querySelector('[data-drawer-close], a, button, input');
    f && setTimeout(() => f.focus(), 60);
  };
  const closeDrawer = d => {
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open')) body.classList.remove('is-locked');
    header && header.classList.toggle('is-solid', scrollY > 40);
    lastFocus && lastFocus.focus && lastFocus.focus();
  };
  document.addEventListener('click', e => {
    const o = e.target.closest('[data-drawer-open]');
    if (o) {
      if (o.dataset.drawerOpen === 'CartDrawer' && T.cartType !== 'drawer') return;
      e.preventDefault();
      openDrawer(o.dataset.drawerOpen);
      return;
    }
    const c = e.target.closest('[data-drawer-close]');
    if (c) { e.preventDefault(); closeDrawer(c.closest('.drawer')); }
  });
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') { const d = $('.drawer.is-open'); d && closeDrawer(d); }
  });

  /* ---------------- Localización ---------------- */
  document.addEventListener('change', e => {
    if (e.target.matches('[data-loc-select]')) e.target.form.submit();
  });

  /* ---------------- Cantidad (+/-) ---------------- */
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-qty-step]');
    if (!b) return;
    const input = b.closest('.qty').querySelector('input');
    const min = +input.min || 0;
    const v = Math.max(min, (+input.value || 0) + (+b.dataset.qtyStep));
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------------- Carrito ---------------- */
  const updateCount = n => $$('[data-cart-count]').forEach(el => { el.textContent = n; el.dataset.count = n; });

  const renderDrawer = async () => {
    try {
      const res = await fetch(`${T.routes.root.replace(/\/$/, '')}/?sections=cart-drawer`);
      const json = await res.json();
      const doc = new DOMParser().parseFromString(json['cart-drawer'], 'text/html');
      const fresh = doc.querySelector('#CartDrawer .drawer__panel');
      const cur = $('#CartDrawer .drawer__panel');
      if (fresh && cur) cur.replaceWith(fresh);
    } catch (err) { /* el carrito sigue funcionando en /cart */ }
  };

  const cartChange = async (line, quantity) => {
    const drawer = $('#CartDrawer');
    drawer && drawer.classList.add('is-busy');
    try {
      const res = await fetch(T.routes.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity })
      });
      const cart = await res.json();
      if (!res.ok) throw new Error(cart.description || T.strings.cartError);
      updateCount(cart.item_count);
      await renderDrawer();
    } catch (err) {
      const el = $('#CartDrawer [data-cart-error]');
      el && (el.textContent = err.message || T.strings.cartError);
    }
    drawer && drawer.classList.remove('is-busy');
  };

  document.addEventListener('change', e => {
    const input = e.target.closest('#CartDrawer [data-line] input');
    if (input) cartChange(+input.closest('[data-line]').dataset.line, +input.value);
    const pageInput = e.target.closest('[data-cart-page] .qty input');
    if (pageInput) { clearTimeout(pageInput._t); pageInput._t = setTimeout(() => pageInput.form.submit(), 500); }
  });
  document.addEventListener('click', e => {
    const rm = e.target.closest('#CartDrawer [data-remove]');
    if (rm) { e.preventDefault(); cartChange(+rm.closest('[data-line]').dataset.line, 0); }
  });

  /* ---------------- Producto: variantes + añadir ---------------- */
  const initProduct = scope => {
    const dataEl = scope.querySelector('[data-variants]');
    if (!dataEl) return;
    const variants = JSON.parse(dataEl.textContent);
    const form = scope.querySelector('form[data-product-form]');
    const idInput = form && form.querySelector('[name="id"]');
    const btn = form && form.querySelector('[data-add]');
    const priceEl = scope.querySelector('[data-price]');
    const stockEl = scope.querySelector('[data-stock]');
    const msg = scope.querySelector('[data-product-message]');
    const groups = $$('[data-option-index]', scope);
    const updateUrl = scope.hasAttribute('data-update-url');

    const selected = () => groups.map(g => { const c = g.querySelector('input:checked'); return c ? c.value : null; });

    const markAvailability = sel => {
      groups.forEach((g, gi) => {
        $$('input', g).forEach(inp => {
          const test = sel.slice(); test[gi] = inp.value;
          const ok = variants.some(v => v.available && v.options.every((o, i) => o === test[i]));
          inp.classList.toggle('is-unavailable', !ok);
        });
        const lab = g.querySelector('[data-selected-value]');
        const c = g.querySelector('input:checked');
        if (lab && c) lab.textContent = c.value;
      });
    };

    const update = () => {
      const sel = selected();
      /* Productos sin selectores (una sola variante): usar esa variante */
      const v = groups.length
        ? variants.find(x => x.options.every((o, i) => o === sel[i]))
        : (variants.find(x => x.available) || variants[0]);
      markAvailability(sel);
      if (!btn) return;
      if (!v) {
        btn.disabled = true;
        btn.querySelector('span').textContent = T.strings.unavailable;
        return;
      }
      idInput.value = v.id;
      btn.disabled = !v.available;
      btn.querySelector('span').textContent = v.available ? T.strings.addToCart : T.strings.soldOut;
      if (priceEl) priceEl.innerHTML = v.price_html;
      if (stockEl) {
        stockEl.textContent = v.stock_text;
        stockEl.className = 'product__stock ' + (v.stock_class || '');
        stockEl.hidden = !v.stock_text;
      }
      if (updateUrl && groups.length) history.replaceState({}, '', `${location.pathname}?variant=${v.id}`);
      if (v.media) {
        const m = scope.querySelector(`[data-media-id="${v.media}"]`);
        const gal = m && m.parentElement;
        if (m && gal) {
          if (getComputedStyle(gal).overflowX === 'auto') gal.scrollTo({ left: m.offsetLeft - gal.offsetLeft, behavior: RM ? 'auto' : 'smooth' });
          else if (m !== gal.firstElementChild) gal.prepend(m);
        }
      }
    };
    groups.forEach(g => g.addEventListener('change', update));
    update();

    if (form && T.cartType === 'drawer' && document.getElementById('CartDrawer')) {
      form.addEventListener('submit', async e => {
        e.preventDefault();
        btn.classList.add('is-loading');
        btn.setAttribute('aria-busy', 'true');
        msg && (msg.textContent = '');
        try {
          const res = await fetch(T.routes.cartAdd + '.js', {
            method: 'POST',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: new FormData(form)
          });
          const data = await res.json();
          if (!res.ok) throw new Error(data.description || T.strings.cartError);
          const cart = await (await fetch(T.routes.cart + '.js')).json();
          updateCount(cart.item_count);
          await renderDrawer();
          openDrawer('CartDrawer');
        } catch (err) {
          msg && (msg.textContent = err.message || T.strings.cartError);
        }
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
      });
    }

    /* Puntos de galería en móvil */
    const gal = scope.querySelector('.product__gallery');
    const dots = $$('.product__dots span', scope);
    if (gal && dots.length) {
      gal.addEventListener('scroll', () => {
        const i = Math.round(gal.scrollLeft / gal.clientWidth);
        dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
      }, { passive: true });
    }
  };
  $$('[data-product]').forEach(initProduct);

  /* ---------------- Filtros de colección ---------------- */
  $$('form[data-facets]').forEach(f => {
    f.addEventListener('change', e => {
      if (e.target.matches('input[type="number"]')) return;
      f.submit();
    });
    $$('input[type="number"]', f).forEach(i => i.addEventListener('change', () => { clearTimeout(i._t); i._t = setTimeout(() => f.submit(), 700); }));
  });
  document.addEventListener('click', e => {
    const t = e.target.closest('[data-facets-toggle]');
    if (t) {
      const f = t.closest('.facets');
      f.classList.toggle('is-open');
      t.setAttribute('aria-expanded', f.classList.contains('is-open'));
    }
  });

  /* ---------------- Editor de temas ---------------- */
  document.addEventListener('shopify:section:load', e => {
    initReveal(e.target);
    initCounters(e.target);
    $$('[data-product]', e.target).forEach(initProduct);
    $$('.hero', e.target).forEach(h => h.classList.add('is-ready'));
  });
})();
